<template>
    <div class="content">
        <div class="content_box tableParent public_box">
            <div class="search_box">
                <!--检索部分-->
                <el-form :inline="true" :model="navForm" class="demo-form-inline">
                    <el-form-item label="车牌号/车架号/设备编号:">
                        <el-input class="width_150" v-model="navForm.condition.search" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="运营公司:" prop="subTenantId">
                        <el-cascader size="small" popper-class="cascaderStyle" ref="companyRef" v-model="navForm.condition.cascaderVal" :options="cascCaderOptions" :props="cascCaderProps" placeholder="请选择" :show-all-levels="false" @change="handleSelectCost" filterable clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="驾驶日期:">
                        <el-date-picker class="widthDate" size="small" v-model="dateTimeVal" @change="dateChange" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="驾驶时间:">
                        <el-time-picker class="width_120" size="small" v-model="navForm.condition.tripTimePeriodMin" value-format="HH:mm:ss"> </el-time-picker>
                        至
                        <el-time-picker class="width_120" size="small" v-model="navForm.condition.tripTimePeriodMax" value-format="HH:mm:ss"> </el-time-picker>
                        <!-- <el-time-picker class="widthDateTime" size="small" is-range v-model="dateVal" @change="dateTimeChange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"> </el-time-picker> -->
                    </el-form-item>
                    <el-form-item label="产品类型:" prop="condition.deviceType" v-if="productTypeData && productTypeData.length > 1">
                        <el-select v-model="navForm.condition.deviceType" placeholder="请选择" size="small" class="width_150">
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.dictName" :value="item.metaData"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" style="margin-left: 0.2rem" @click="searchTable">查询</el-button>
                        <el-button type="primary" size="small" style="margin-left: 0.2rem" :loading="downloadLoading" @click="queryDownload">下载</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!--table表格部分-->
            <el-table ref="multipleTable" class="tableHeightAdaptive" v-loading="loading" :data="tableData" @sort-change="sortChange">
                <el-table-column prop="platNo" label="车牌号"></el-table-column>
                <el-table-column prop="deviceNumber" label="设备编号"></el-table-column>
                <el-table-column prop="startTime" label="开始时间" width="156" sortable="custom"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="156" sortable="custom"></el-table-column>
                <el-table-column prop="commercialVehicleScore" label="驾驶评分" sortable="custom"></el-table-column>
                <el-table-column prop="drivingDurationMinutes" label="驾驶时长（h）" sortable="custom" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.drivingDurationHours }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mileage" label="驾驶里程（km）" sortable="custom" width="150"></el-table-column>
                <el-table-column label="操作" v-if="!userInfo.batchId">
                    <template slot-scope="scope">
                        <div class="operation_box">
                            <el-button type="primary" size="small" @click="openNewPage(scope.row)">查看详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页部分-->
            <el-pagination style="margin-top: 0.2rem" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="navForm.pageNo" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20]" :page-size="navForm.pageSize" :total="totalPage"> </el-pagination>
        </div>
    </div>
</template>

<script>
let _this;
export default {
    name: 'DrivingScore',
    props: {
        msg: String
    },
    data() {
        return {
            downloadLoading: false,
            rid: '',
            loading: false,
            fullscreenLoading: false,
            detailPageVisible: false,
            formType: '', //页面类型
            navForm: {
                //储存搜索框的检索条件信息
                condition: {
                    cascaderVal: null,
                    companyId: null,
                    search: null,
                    fleetId: null,
                    deviceNumber: null,
                    tripTimeMin: null,
                    tripTimeMax: null,
                    deviceType: null,
                    tripTimePeriodMin: '00:00:00',
                    tripTimePeriodMax: '23:59:59'
                },
                orders: [],
                pageNo: 1,
                pageSize: 10
            },
            modeForm: {
                name: ''
            },
            batchIdList: [], //车队
            totalPage: 1, //总页数tableData:[],
            tableData: [],
            companyList: [],
            cascCaderProps: {
                children: 'subTenantTreeLists',
                label: 'tenantName',
                value: 'tenantId',
                expandTrigger: 'hover',
                checkStrictly: true
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            dateTimeVal: '',
            dateVal: []
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            if (typeData && typeData.length) {
                let expandItem = typeData.find((item) => item.expandInfo);
                if (this.navForm.condition.deviceType == null) {
                    this.navForm.condition.deviceType = expandItem ? expandItem.metaData : typeData[0].metaData;
                }
            }
            return typeData;
        },
        cascCaderOptions() {
            return this.$store.state.common.companyTreeData;
        }
    },
    mounted() {
        _this = this;
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.navForm.companyId = this.userInfo.company;
        this.selectDate(7);
        // 初始化开始时间（示例：当天 00:00:00，可根据需求调整）
        const start = new Date();
        start.setHours(0, 0, 0, 0); // 时、分、秒、毫秒都设为0

        // 初始化结束时间为当天 23:59:59
        const end = new Date();
        end.setHours(23, 59, 59, 0); // 时=23，分=59，秒=59，毫秒=0
        this.dateVal = [start, end];
        this.dateTimeChange(this.dateVal);

        this.setQueryParams();

        this.getTbodyData();
    },
    methods: {
        setQueryParams() {
            if (this.$route.query && this.$route.query.signStr == 'screen') {
                let conditionData = this.$route.query.condition;
                this.navForm.orders = this.$route.query.orders;

                for (const key in conditionData) {
                    this.navForm.condition[key] = conditionData[key];
                }
            }
        },
        formatTimeToHHMMSS(date) {
            // 提取时分秒，不足2位补0
            const hours = String(date.getHours()).padStart(2, '0'); // 小时（00-23）
            const minutes = String(date.getMinutes()).padStart(2, '0'); // 分钟（00-59）
            const seconds = String(date.getSeconds()).padStart(2, '0'); // 秒（00-59）
            return `${hours}:${minutes}:${seconds}`;
        },
        dateChange(val) {
            if (val.length > 0) {
                this.navForm.condition.tripTimeMin = val[0] + ' 00:00:00';
                this.navForm.condition.tripTimeMax = val[1] + ' 23:59:59';
            } else {
                this.navForm.condition.tripTimeMin = null;
                this.navForm.condition.tripTimeMax = null;
            }
        },
        dateTimeChange(val) {
            // if (val.length > 0) {
            //     this.navForm.condition.tripTimePeriodMin = this.formatTimeToHHMMSS(val[0]);
            //     this.navForm.condition.tripTimePeriodMax = this.formatTimeToHHMMSS(val[1]);
            // } else {
            //     this.navForm.condition.tripTimePeriodMin = null;
            //     this.navForm.condition.tripTimePeriodMax = null;
            // }
        },
        queryDownload() {
            this.downloadFile();
        },
        downloadFile() {
            this.downloadLoading = true;

            if (!this.navForm.condition.tripTimePeriodMin || !this.navForm.condition.tripTimePeriodMax) {
                this.$message.error('请正确填写驾驶时间范围');
                this.downloadLoading = false;
                return;
            }

            let downloadTripData = JSON.parse(JSON.stringify(this.navForm));
            if (downloadTripData.condition && downloadTripData.condition.deviceType == 2) {
                downloadTripData.condition.deviceType = 1;
                downloadTripData.condition.shortTermRental = true;
            } else if (downloadTripData.condition && downloadTripData.condition.deviceType == 1) {
                downloadTripData.condition.shortTermRental = false;
            }
            this.$download({ method: 'post', url: '/ubi/api/trip/download', data: downloadTripData }).then((res) => {
                this.downloadLoading = false;
                this.$$exportFile(res.data, decodeURIComponent(res.headers.filename));
            });
        },
        handleSelectCost(val) {
            this.navForm.condition.companyId = val && val.length > 0 ? val[val.length - 1] : null;
            this.$refs.companyRef.dropDownVisible = false;
        },
        loadFleetList(id) {
            return new Promise((resolve, reject) => {
                this.$request({ method: 'get', url: '/ubi/api/tenant/fleetList?companyId=' + id, params: {} }).then((res) => {
                    let data = res.data;
                    if (data.code == 200 && data.data) {
                        data.data.forEach((item) => {
                            item.name = item.customerId;
                            // item.leaf = true;
                        });
                        resolve(data.data);
                    }
                });
            });
        },
        loadLastList(id) {
            return new Promise((resolve, reject) => {
                this.$request({ method: 'get', url: '/ubi/api/tenant/fleetList?companyId=' + id, params: {} }).then((res) => {
                    let data = res.data;
                    if (data.code == 200 && data.data) {
                        data.data.forEach((item) => {
                            item.name = item.customerId;
                            item.leaf = true;
                        });
                        resolve(data.data);
                    } else {
                        resolve();
                    }
                });
            });
        },

        //排序
        sortChange(column) {
            let tmpIndex = this.navForm.orders.findIndex((res) => {
                return res.column == column.prop;
            });
            let tmpOrderItem = {
                asc: column.order == 'ascending' ? true : false,
                column: column.prop
            };
            this.navForm.orders = [];
            column.order && this.navForm.orders.push(tmpOrderItem);
            this.getTbodyData();
        },
        openNewPage(row) {
            let routeUrl = this.$router.resolve({
                path: '/analysis/trajectoryAnalysis',
                query: {
                    deviceType: this.navForm.condition.deviceType,
                    deviceNumber: row.deviceNumber,
                    rowStartTime: row.startTime,
                    tripUuid: row.tripUuid
                }
            });
            window.open(routeUrl.href, '_blank');
        },
        //选择日期
        selectDate(sign) {
            const start = new Date();
            const end = new Date();
            let tmpStart, tmpEnd;
            if (sign == 'today') {
                tmpStart = this.$$dateFormatting(start, 'yyyy-MM-dd');
                tmpEnd = this.$$dateFormatting(end, 'yyyy-MM-dd');
            } else {
                tmpStart = this.$$dateFormatting(new Date(start.getTime() - 3600 * 1000 * 24 * sign), 'yyyy-MM-dd');
                tmpEnd = this.$$dateFormatting(end, 'yyyy-MM-dd');
            }

            this.dateTimeVal = [tmpStart, tmpEnd];
            this.dateChange(this.dateTimeVal);
        },
        //点击查询
        searchTable() {
            this.navForm.pageNo = 1;
            this.getTbodyData();
        },
        //获取tbody里的数据
        getTbodyData() {
            var _this = this;

            if (!this.navForm.condition.tripTimePeriodMin || !this.navForm.condition.tripTimePeriodMax) {
                this.$message.error('请正确填写 “驾驶时间范围”');
                return;
            }
            this.loading = true;
            _this.tableData = []; //  清空table的值
            let tripData = JSON.parse(JSON.stringify(this.navForm));
            if (tripData.condition && tripData.condition.deviceType == 2) {
                tripData.condition.deviceType = 1;
                tripData.condition.shortTermRental = true;
            } else if (tripData.condition && tripData.condition.deviceType == 1) {
                tripData.condition.shortTermRental = false;
            }
            this.$request({ method: 'post', url: '/ubi/api/trip/page', data: tripData }).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    _this.tableData = res.data.list;
                    _this.totalPage = parseInt(res.data.total);
                } else {
                    _this.totalPage = 0;
                }
            });
        },
        toHourMinute(minutes) {
            return Math.floor(minutes / 60) + '小时' + (minutes % 60).toFixed(2) + '分';
        },
        //分页数据多少条change
        handleSizeChange(val) {
            this.navForm.pageSize = val;
            this.getTbodyData();
        },
        //分页：当前页改变之后的函数
        handleCurrentChange(val) {
            this.navForm.pageNo = val;
            this.getTbodyData(this.activityState);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/css/public.css';
.content {
    height: 100%;
}
.widthDate {
    width: 220px !important;
    padding-right: 0;
}
.widthDateTime {
    width: 220px !important;
    padding-right: 0;
}
/deep/ .el-range-separator {
    width: auto !important;
}
.width_120 {
    width: 120px !important;
}
.dialogTxt {
    line-height: 24px;
}
.indentTxt {
    text-indent: 2em;
}
</style>
